export class SurveyForm {
    name: string;
    surname: string;
    room_no: string;
    phone_no: string;
    email: string;
}